export enum NeonType {
  PLAYER = 'PLAYER',
  STRUCTURE = 'STRUCTURE',
}
